export {
  default,
  default as ErrorBoundary,
  withErrorBoundary
} from './ErrorBoundary';
export { default as ErrorBoundaryFallbackComponent } from './ErrorBoundaryFallbackComponent';
export type { OwnProps as ErrorBoundaryFallbackComponentProps } from './ErrorBoundaryFallbackComponent';
